const SUFFIX = "v2";

export const PLAN_REMOVAL_BOTTOMSHEET_DATA_TEST_IDS = {
    CONTAINER: `plan-removal-bottomsheet-container-${SUFFIX}`,
    HEADING: `plan-removal-bottomsheet-heading-${SUFFIX}`,
    CONTENT: `plan-removal-bottomsheet-content-${SUFFIX}`,
    PRIMARY_CTA: `plan-removal-bottomsheet-primary-cta-${SUFFIX}`,
    SECONDARY_CTA: `plan-removal-bottomsheet-secondary-cta-${SUFFIX}`,
};
